import {generateTTExcel} from "./ApiCalls";
import {Button, Dialog, Label, Pane, TextInput, TextInputField, toaster} from "evergreen-ui";
import React from "react";
import {generateExcelViaTemplateId} from "../decadeConstructor/ApiCalls";
import SuspenseSpinner from "../../../Utils/SuspenseSpinner";
import SmartButton from "../common/SmartButton";
import {MAX_OUTPUT_FORM_NAME_LENGTH} from "../common/OutputFormsConstraints";
import {onDownloadFileAction} from "../common/OutputFormsDownloadFileFromConstructor";
import {getDefaultNameExactToDays} from "../common/DateMethods";

export default function CreateOutputFormTTDialog({constructor, isShown, setIsShown, viaTemplateId= false, id, name}) {

    let [startPeriod, setStartPeriod] = React.useState("T00:00:01")
    let [endPeriod, setEndPeriod] = React.useState("T23:59:59")

    let [stationName, setStationName] = React.useState("")

    let [outputFormName, setOutputFormName] = React.useState(stationName)
    let [isOutputFormNameCustom, setIsOutputFormNameCustom] = React.useState(false)

    const [isFetch, setIsFetch] = React.useState(false)

    function updateStationName() {
        setStationName(
            name !== undefined ?
                name !== "" ?
                    name :
                    checkConstructor
                : checkConstructor
        )
    }

    function checkConstructor() {
        return constructor.station.name !== undefined ?
            constructor.station.name !== "" ?
                constructor.station.name :
                ""
            : ""
    }

    function clearDialogFields() {
        setOutputFormName(constructor.station.name)
        setStartPeriod('T00:00:01')
        setEndPeriod('T23:59:59')
        setIsOutputFormNameCustom(false)
    }

    function isFormButtonDisabled() {
        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        const dateIncorrect =  startPeriod === "T00:00:01" || endPeriod === "T23:59:59" || start - end > 0

        return outputFormName.trim().length === 0 || isFetch || dateIncorrect
    }

    function getMessageForTooltip() {
        if (outputFormName.trim().length === 0 && (startPeriod === "T00:00:01" || endPeriod === "T23:59:59")) {
            return "Выберите период для которого будет сформирована выходная форма и задайте её наименование"
        }

        if (startPeriod === "T00:00:01" || endPeriod === "T23:59:59") {
            return "Выберите период для которого будет сформирована выходная форма"
        }

        if (outputFormName.trim().length === 0) {
            return "Задайте наименование для выходной формы"
        }

        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        if (start - end > 0) {
            return "Дата начала периода не может быть позднее, чем дата окончания этого периода"
        }
    }

    function createOutputForm() {

        if (outputFormName.length > MAX_OUTPUT_FORM_NAME_LENGTH) {
            toaster.danger("Ошибка! Наименование выходной формы не может быть длиннее " + MAX_OUTPUT_FORM_NAME_LENGTH
                +  " символов!")
            setIsFetch(false)
            return;
        }

        if (viaTemplateId) {
            setIsFetch(true)
            generateExcelViaTemplateId(id, {start: startPeriod, end: endPeriod},
                getDefaultOutputFormName(
                    stationName,
                    startPeriod,
                    endPeriod))
                .then((response) => {
                toaster.success('Файл сохранён!')
                clearDialogFields()
                setIsFetch(false)
            }).catch(() => {
                toaster.danger("Ошибка!")
                clearDialogFields()
                setIsFetch(false)
            })
        } else {
            setIsFetch(true)
            generateTTExcel({start: startPeriod, end: endPeriod}, constructor,
                getDefaultOutputFormName(
                    stationName,
                    startPeriod,
                    endPeriod))
                .then((response) => {
                toaster.success('Файл сохранён!')
                clearDialogFields()
                setIsFetch(false)
                //скачиваем форму сразу
                onDownloadFileAction(response.data.id)
            }).catch(() => {
                toaster.danger("Ошибка!")
                clearDialogFields()
                setIsFetch(false)
            })
        }
    }

    function setCustomOutputFormName(name) {
        setIsOutputFormNameCustom(true)
        setOutputFormName(name)
    }

    function getDefaultOutputFormName(stationName, startTime, endTIme) {
        if (isOutputFormNameCustom) {
            return outputFormName
        }

        return getDefaultNameExactToDays(stationName, startTime, endTIme)
    }

    function setStartDateWithFormNameSaving(value) {
        updateStationName()
        setStartPeriod(value + ":00")

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToDays(
                    stationName,
                    value + ":00",
                    endPeriod
                ))
        }
    }

    function setEndDateWithFormNameSaving(value) {
        updateStationName()
        setEndPeriod(value + ":00")

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToDays(
                    stationName,
                    startPeriod,
                    value + ":00"
                ))
        }
    }

    return (
        <Dialog
            isShown={isShown}
            title="Формирование выходной формы"
            onOpenComplete={() => {
                clearDialogFields()
            }}
            cancelLabel="Отменить"
            footer={
                <Pane>
                    <Button marginRight={5} onClick={() => setIsShown(false)}>Отменить</Button>
                    <SmartButton
                        disabledTooltip={getMessageForTooltip()}
                        buttonText={"Сформировать"}
                        isPrimary={true}
                        isDisabled={isFormButtonDisabled()}
                        onClickAction={() => createOutputForm()}
                    />
                </Pane>
            }
            onCloseComplete={() => setIsShown(false)}
            onConfirm={() => createOutputForm()}
            confirmLabel="Сформировать"
        >
            {isFetch ? <SuspenseSpinner/> : <>
                <Pane>
                    <Label>Дата формирования</Label>
                </Pane>
                <Pane display={"flex"} marginTop={10}>
                    <Pane display={"flex"} columnGap={10}>
                        <Label>c</Label>
                        <TextInput
                            width="auto"
                            type="datetime-local"
                            name="startDate"
                            max={endPeriod}
                            onChange={val => {
                                setStartDateWithFormNameSaving(val.target.value)
                            }}
                        />
                        <Label>по</Label>
                        <TextInput
                            width="auto"
                            type="datetime-local"
                            name="endDate"
                            min={startPeriod}
                            onChange={val => {
                                setEndDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane marginRight={30} marginTop={30}>
                    <TextInputField
                        label="Введите наименование выходной формы"
                        width={413}
                        value={
                            getDefaultOutputFormName(
                                stationName,
                                startPeriod,
                                endPeriod
                            )}
                        onChange={e => setCustomOutputFormName(e.target.value)}
                    />
                </Pane>
            </>}

        </Dialog>
    )
}